import name from './name'

const selectSliceData = state => state[name]

const selectAll = state => selectSliceData(state)
const selectQuizState = (state, quizId) => selectSliceData(state)[quizId]

export { selectAll, selectQuizState }
